import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllAccommodationAttributesQuery } from '@custom/schema';

export const useAccommodationAttributes = () => {
  return useStaticQuery(graphql(AllAccommodationAttributesQuery));
};
